import { isTauri as tauriIsTauri } from "@tauri-apps/api/core";

/** True when running inside the Tauri WebView. */
export function isTauri(): boolean {
  return tauriIsTauri();
}

/** True when OS-shell capabilities (native dialogs, menu, …) should be preferred. */
export function isNativeShell(): boolean {
  return isTauri();
}
